import { useEffect } from 'react';
import SEOHead from '../../components/feature/SEOHead';
import WorksheetSubmodalidadesHero from './components/WorksheetSubmodalidadesHero';
import PassosSubmodalidades from './components/PassosSubmodalidades';
import PraticaSubmodalidades from './components/PraticaSubmodalidades';
import CompromissoSubmodalidades from './components/CompromissoSubmodalidades';
import CTASubmodalidades from './components/CTASubmodalidades';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const worksheetSubmodalidadesSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: 'Worksheet Submodalidades PNL — Guia Completo',
    description: 'Guia completo de Submodalidades de PNL para modificar as qualidades sensoriais das representações mentais e transformar emoções.',
    image: `${SITE_URL}/og-worksheet-submodalidades.png`,
    totalTime: 'PT40M',
    step: [
      {
        '@type': 'HowToStep',
        position: 1,
        name: 'Escolha as Experiências',
        text: 'Identifique uma experiência positiva e uma negativa para trabalhar. Seja específico na descrição de cada uma.'
      },
      {
        '@type': 'HowToStep',
        position: 2,
        name: 'Explore Submodalidades Visuais',
        text: 'Ajuste brilho, tamanho, distância, foco, cor, movimento e outras qualidades visuais das imagens mentais.'
      },
      {
        '@type': 'HowToStep',
        position: 3,
        name: 'Explore Submodalidades Auditivas',
        text: 'Modifique volume, tom, ritmo, localização, clareza e outras qualidades dos sons internos.'
      },
      {
        '@type': 'HowToStep',
        position: 4,
        name: 'Explore Submodalidades Cinestésicas',
        text: 'Altere intensidade, localização, temperatura, textura, movimento e outras qualidades das sensações corporais.'
      },
      {
        '@type': 'HowToStep',
        position: 5,
        name: 'Mapping Across (Transferência)',
        text: 'Transfira as qualidades da experiência positiva para a negativa, modificando as submodalidades uma a uma.'
      },
      {
        '@type': 'HowToStep',
        position: 6,
        name: 'Teste e Ancore',
        text: 'Verifique se a mudança foi efetiva e ancore o novo estado emocional para acesso futuro.'
      }
    ]
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Worksheet Submodalidades PNL | Guia Completo — Carta do Eu Futuro',
    url: `${SITE_URL}/worksheet-submodalidades`,
    description: 'Worksheet completo de Submodalidades de PNL. Aprenda a modificar as qualidades sensoriais das suas representações mentais para transformar emoções e comportamentos.',
    inLanguage: 'pt-BR',
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Início', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'Worksheet Submodalidades', item: `${SITE_URL}/worksheet-submodalidades` },
      ],
    },
  }
];

export default function WorksheetSubmodalidadesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const salvarWorksheet = () => {
    const data = {
      experiencias: JSON.parse(localStorage.getItem('worksheet-submodalidades') || '{}'),
      compromisso: JSON.parse(localStorage.getItem('compromisso-submodalidades') || '{}'),
      dataExportacao: new Date().toISOString()
    };
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `worksheet-submodalidades-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Worksheet Submodalidades PNL | Guia Completo — Carta do Eu Futuro"
        description="Worksheet completo de Submodalidades de PNL. Aprenda a modificar as qualidades sensoriais das suas representações mentais para transformar emoções e comportamentos."
        keywords="worksheet submodalidades, PNL, submodalidades, representações mentais, transformação emocional"
        canonical="/worksheet-submodalidades"
        schema={worksheetSubmodalidadesSchema}
      />
      <WorksheetSubmodalidadesHero />
      <PassosSubmodalidades />
      <PraticaSubmodalidades />
      <CompromissoSubmodalidades />
      <CTASubmodalidades />
      <button
        onClick={salvarWorksheet}
        className="fixed bottom-8 right-8 w-14 h-14 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-full shadow-2xl hover:scale-110 transition-all duration-300 flex items-center justify-center z-50"
        title="Salvar Worksheet"
      >
        <i className="ri-save-line text-2xl"></i>
      </button>
    </div>
  );
}